const legacyBasePrefix = "/v2";

export const normalizeTrendingPath = (rawPath: string): string => {
    const path = rawPath.trim();
    if (!path) {
        return "";
    }
    if (path === legacyBasePrefix) {
        return "/";
    }
    if (path.startsWith(`${legacyBasePrefix}/`)) {
        return path.substring(legacyBasePrefix.length);
    }
    return path;
};
